import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Confirmación con el estilo de la plataforma (en lugar de window.confirm).
// Escape y el clic fuera cancelan; el evento de Escape no llega a otros listeners
// del documento para que no cierre también la ventana que lo abrió.
function ConfirmDialog({
  title,
  children,
  note,
  confirmLabel = 'Sí, eliminar',
  cancelLabel = 'Cancelar',
  danger = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  const cancelRef = useRef(onCancel);
  cancelRef.current = onCancel;
  const busyRef = useRef(busy);
  busyRef.current = busy;

  useEffect(() => {
    const alPulsar = (event) => {
      if (event.key !== 'Escape') return;
      event.stopImmediatePropagation();
      if (!busyRef.current) cancelRef.current();
    };
    // En captura y antes que los listeners del resto de la app.
    document.addEventListener('keydown', alPulsar, true);
    return () => document.removeEventListener('keydown', alPulsar, true);
  }, []);

  return createPortal(
    <div className="modal-overlay" onClick={() => !busy && onCancel()}>
      <div
        className="modal-content confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 id="confirm-dialog-title">{title}</h3>
          <button type="button" className="modal-close" onClick={onCancel} disabled={busy}>
            ×
          </button>
        </div>
        <div className="confirm-modal-body">
          <p>{children}</p>
          {note ? <p className="confirm-modal-note">{note}</p> : null}
        </div>
        <div className="confirm-modal-actions">
          <button type="button" className="admin-btn secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? 'admin-btn danger' : 'admin-btn primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmDialog;
